import type { CalendarDayLabel } from '../calendarTemporalLabels';
import { CalendarGranularity } from '../types';

const HEADER_CLASS =
    'flex flex-col justify-center border-r border-t border-light-gray bg-primary-light p-2 text-center text-more-small font-medium text-dark-gray last:border-r-0 first:border-l first:rounded-tl-md first:overflow-hidden';
const DAY_AND_MONTH_CLASS = 'text-small capitalize';

type WeekDayHeaderProps = Readonly<{
    mode: CalendarGranularity.Week | CalendarGranularity.Day;
    dayLabel: CalendarDayLabel | undefined;
}>;

export function WeekDayHeader({ mode, dayLabel }: WeekDayHeaderProps) {
    if (mode === CalendarGranularity.Week) {
        return (
            <div className={HEADER_CLASS}>
                <div>{dayLabel?.weekday_short ?? ''}</div>
                <div className={DAY_AND_MONTH_CLASS}>{dayLabel?.day_and_month ?? ''}</div>
            </div>
        );
    }
    return (
        <div className={HEADER_CLASS}>
            <div className={DAY_AND_MONTH_CLASS}>{dayLabel?.long_weekday_date ?? ''}</div>
        </div>
    );
}
